export const eventBus = new Vue();

const JobModel = {
    data() {
        return {
            JobModel: {
                getJob: id =>
                    this.$http.get(`v2/jobs/find/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                viewJobsListing: (params) =>
                    this.$http.get('/v2/jobs/job-list', {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                getAllJobList: (params) =>
                    this.$http.get('/v2/admin/jobs/all-recommendable-jobs', {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                getJobTags: (params) =>
                    this.$http.get('/v2/admin/tags/list/', {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                createTagAndSpecialization: (data, dataType) =>
                    this.$http.post(`v2/admin/${dataType}/create`, data)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getJobSpecializations: (params) =>
                    this.$http.get(`/v2/admin/specializations/list/`, {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                deleteJobSpecialization: (id) =>
                    this.$http.delete(`/v2/admin/specializations/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),
                        
                deleteJobTag: (id) =>
                    this.$http.delete(`/v2/admin/tags/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getJobWorkFlow: (id) =>
                    this.$http.get(`/v2/admin/jobs/fetch-job-application-workflow/${id}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                duplicate: (data) =>
                    this.$http.post(`/jobs/duplicate`, data)
                        .then(r => r.data, e => Promise.reject(e.data)),

                changeStatus: (data) =>
                    this.$http.post(`/job-status`, data)
                        .then(r => r.data, e => Promise.reject(e.data)),
                
                deleteJob: (jobId) =>
                    this.$http.delete(`/v2/admin/jobs/${jobId}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                restoreJob: (jobId) =>
                    this.$http.get(`/v2/admin/jobs/restore/${jobId}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                makePrivateOrPublic: (data) =>
                    this.$http.post(`/make-private`, data)
                        .then(r => r.data, e => Promise.reject(e.data)),

                bulkUploadCandidate: (job_id, data) =>
                    this.$http.post(`/v3/admin/jobs/${job_id}/upload-applicants-to-workflow-step`, data, { 
                        onUploadProgress: evt => eventBus.$emit("bulk-upload-candidate-upload-progress", evt)
                     })
                        .then(r => r.data, e => Promise.reject(e.data)),

                bulkUploadApplicants: (job_id, data) =>
                    this.$http.post(`/v3/admin/jobs/${job_id}/bulk-upload-candidates`, data, { 
                        onUploadProgress: evt => eventBus.$emit("bulk-upload-applicants-upload-progress", evt)
                        })
                        .then(r => r.data, e => Promise.reject(e.data)),
            
                getBulkUploadReport: (batchId, resource) =>
                    this.$http.get(`v2/admin/get-batch/${batchId}/${resource}`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getCompany: () =>
                    this.$http.get(`v2/jobs/company`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                generateJobIdFilter: () =>
                    this.$http.get(`v2/admin/jobs/generate-filter`)
                        .then(r => r.data, e => Promise.reject(e.data)),

                moveApplicantsToStep: (job_id, payload) =>
                    this.$http.post(`v2/admin/jobs/${job_id}/move-applicants-to-workflow-step`, payload)
                        .then(r => r.data, e => Promise.reject(e.data)),

                getFile: (params) =>
                    this.$http.get('/v2/file/get-file', {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                getJobPoolSummary: () =>
                    this.$http.get('/v2/admin/analytics/job-pool-summary')
                        .then(r => r.data, e => Promise.reject(e.data)),

                getApplicationMonitorAnalytic: (params) =>
                    this.$http.get('/v2/admin/analytics/application-monitor', {params})
                        .then(r => r.data, e => Promise.reject(e.data)),

                getJobListing: (params) =>
                    this.$http.get('/v2/admin/jobs/list', {params})
                        .then(r => r.data, e => Promise.reject(e.data)),
            }
        }
    },
    methods: {
        formattedExpiryDate(unformattedExpiryDate) {
            const formattedExpiryDate = this.$moment(unformattedExpiryDate).fromNow()
            return formattedExpiryDate
        },
        calculateActiveDates(date) {
            let now = this.$moment()
            const activeDateInDays = now.diff(date, "days")
            const activeDateInSeconds = now.diff(date, "seconds")
            return {
                activeDateInDays,
                activeDateInSeconds
            }
        },
    }
}

export default JobModel;
